// import '../../../../Styles/Toyota.scss'

import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LoadingGif from '../../../../static/images/loading.gif';
import MissingFirstNameForm from './MissingFirstNameForm';
import MissingLastNameForm from './MissingLastNameForm';
import MissingEmailForm from './MissingEmailForm';
import MissingPhoneForm from './MissingPhoneForm';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg';

import AppVars from '../../../../AppVars.js';
import Logger from '../../../../Logger.js';

import {parseCookies, validateSessionToken} from 'account-portal-library/lib/helperFunctions';
import returnHeader from "../Register/RegisterHeaders"

const appVars = AppVars.getInstance()
const logger = Logger.getInstance();


class MissingEmailPhoneNameView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,

        };
    }

    render(){
        return(
            <div>
            <div className = "justify-content-center email-phone-line-box">
                <Row className = "">
                <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                </Row>
                <div
                    id = "missingFieldsSubmissionError"
                    data-testid = "missingFieldsSubmissionError"  
                    className = {`${this.props.isResponseValid === false ? "error-modal" : "none"}`} 
                    role = "alert"
                    aria-hidden = {`${this.props.isResponseValid === false ? "false" : "true"}`}>
                <div className = "error-modal-text">
                The service is down. Please try again shortly.
                </div>
                <span onClick={this.props.hideModal} className = "modal-close">&times;</span>
                </div>
                <div>
                    {returnHeader("FINISH-SOCIAL", this.props.provider, this.props.style)}
                </div>
                <Form id = "missing4FieldsForm" noValidate validated = {this.props.isEmailValid && this.props.isPhoneValid && this.props.isFirstNameValid && this.props.isLastNameValid} onSubmit={this.props.handleMissingFieldsFormSubmit}>
                {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
                <MissingFirstNameForm
                    firstName={this.props.firstName} 
                    handleFirstNameChange={this.props.handleFirstNameChange} 
                    isFirstNameValid={this.props.isFirstNameValid} 
                    setFocusFirstName = {this.props.setFocusFirstName}
                    removeFocusFirstName = {this.props.removeFocusFirstName}
                    firstNameFocus = {this.props.firstNameFocus}
                    onBlurFirstName = {this.props.onBlurFirstName}
                    floatFirstName = {this.props.floatFirstName}
                    />
                    <MissingLastNameForm
                    lastName={this.props.lastName} 
                    handleLastNameChange={this.props.handleLastNameChange} 
                    isLastNameValid={this.props.isLastNameValid} 
                    setFocusLastName = {this.props.setFocusLastName}
                    removeFocusLastName = {this.props.removeFocusLastName}
                    lastNameFocus = {this.props.lastNameFocus}
                    onBlurLastName = {this.props.onBlurLastName}
                    floatLastName = {this.props.floatLastName}
                    />
                <MissingEmailForm 
                    mail={this.props.mail} 
                    handleEmailChange={this.props.handleEmailChange} 
                    isEmailValid={this.props.isEmailValid} 
                    isEmailAvailable={this.props.isEmailAvailable}
                    setFocusEmail = {this.props.setFocusEmail}
                    removeFocusEmail = {this.props.removeFocusEmail}
                    emailFocus = {this.props.emailFocus}
                    onBlurEmail = {this.props.onBlurEmail}
                    floatEmail = {this.props.floatEmail}
                    />
                <MissingPhoneForm
                    emailIsMissing={true} 
                    phone={this.props.telephoneNumber} 
                    handlePhoneChange={this.props.handlePhoneChange} 
                    isPhoneValid={this.props.isPhoneValid} 
                    isPhoneAvailable={this.props.isPhoneAvailable}
                    setFocusPhone = {this.props.setFocusPhone}
                    removeFocusPhone = {this.props.removeFocusPhone}
                    phoneFocus = {this.props.phoneFocus}
                    onBlurPhone = {this.props.onBlurPhone}
                    floatPhone = {this.props.floatPhone}
                    />

                <div className="required required-left-grid-social"><span><span id="redStar">*</span>Required</span></div>
                <div className = "button-right-social">
                    <Button data-testid = "createPasswordButton" bsPrefix = {`${(this.props.isFirstNameValid && this.props.isLastNameValid && this.props.isEmailValid && this.props.isPhoneValid) !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Submit</Button>
                </div>
                </Form>
            </div>
            </div>

          
    );

    }

}




export default MissingEmailPhoneNameView;